import { update, onValue, off, DataSnapshot } from "firebase/database";
import { THEATER_PATH } from "modules/theater/firebase";
import { generateDocRef } from "modules/firebase";
import { TimerParams } from "./redux/slice";

const getTimerDocRef = generateDocRef(
  (theaterId: string) => `${THEATER_PATH}/${theaterId}/Timer`,
);

const setTimerParams = (
  theaterId: string,
  timerParams: Omit<Partial<TimerParams>, "startedAt" | "setupActive">,
) => update(getTimerDocRef(theaterId), { ...timerParams, startedAt: -1 });

const startTimer = (theaterId: string, startedAt: number) =>
  update(getTimerDocRef(theaterId), {
    startedAt,
  });

const stopTimer = (theaterId: string) =>
  update(getTimerDocRef(theaterId), {
    startedAt: -1,
  });

const subscribe = (
  theaterId: string,
  cb: (roundSetup: TimerParams) => void,
) => {
  onValue(getTimerDocRef(theaterId), async (snap: DataSnapshot) => {
    const val = snap.val();

    if (!val) {
      return;
    }

    cb(val);
  });
};

const unsubscribe = (theaterId: string) => {
  off(getTimerDocRef(theaterId));
};

export default {
  getTimerDocRef,
  setTimerParams,
  startTimer,
  stopTimer,
  subscribe,
  unsubscribe,
};
